import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { ILayoutService } from 'vscode/vscode/vs/platform/layout/browser/layoutService.service';
import { IInstantiationService } from 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { IThemeService } from 'vscode/vscode/vs/platform/theme/common/themeService.service';
import { IConfigurationService } from 'vscode/vscode/vs/platform/configuration/common/configuration.service';
import { IContextKeyService } from 'vscode/vscode/vs/platform/contextkey/common/contextkey.service';
import { IKeybindingService } from 'vscode/vscode/vs/platform/keybinding/common/keybinding.service';
import { QuickInputService as QuickInputService$1 } from 'vscode/vscode/vs/platform/quickinput/browser/quickInputService';
import 'vscode/vscode/vs/platform/instantiation/common/extensions';
import { InQuickPickContextKey } from 'vscode/vscode/vs/workbench/browser/quickaccess';

let QuickInputService = class QuickInputService extends QuickInputService$1 {
    constructor(configurationService, instantiationService, keybindingService, contextKeyService, themeService, layoutService) {
        super(instantiationService, contextKeyService, themeService, layoutService, configurationService);
        this.keybindingService = keybindingService;
        this.inQuickInputContext = InQuickPickContextKey.bindTo(this.contextKeyService);
        this.registerListeners();
    }
    registerListeners() {
        this._register(this.onShow(() => this.inQuickInputContext.set(true)));
        this._register(this.onHide(() => this.inQuickInputContext.set(false)));
    }
    createController() {
        return super.createController(this.layoutService, {
            ignoreFocusOut: () => !this.configurationService.getValue('workbench.quickOpen.closeOnFocusLost'),
            backKeybindingLabel: () => this.keybindingService.lookupKeybinding('workbench.action.quickInputBack')?.getLabel() || undefined,
        });
    }
};
QuickInputService = ( __decorate([
    ( __param(0, IConfigurationService)),
    ( __param(1, IInstantiationService)),
    ( __param(2, IKeybindingService)),
    ( __param(3, IContextKeyService)),
    ( __param(4, IThemeService)),
    ( __param(5, ILayoutService))
], QuickInputService));

export { QuickInputService };
